import { render, staticRenderFns } from "./train.vue?vue&type=template&id=51d8df3c&scoped=true&"
import script from "./train.vue?vue&type=script&lang=js&"
export * from "./train.vue?vue&type=script&lang=js&"
import style1 from "./train.vue?vue&type=style&index=1&id=51d8df3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8df3c",
  null
  
)

export default component.exports